import React from "react";

export const RadioLabel = (props) => {
    const {label, value, checkedValue, onChange} = props;
  return (
      <label className="input-label">
          <input
              className="custom-input"
              type="radio"
              value={value}
              checked={value === checkedValue}
              onChange={onChange}
          />
          <p className="radio-label">{label}</p>
      </label>
  )
}